import { Registry } from './registry.model';

export class DataPole extends Registry {

  subRegistry: Registry[] = null;
}
